import React, { useState, useRef } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import { GenerateOTPForSender } from 'Components/Api/NovityDMTAPI';
import { Button, Container, Grid, Paper, Typography } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';
import { useLocation } from 'react-router-dom';
import HOCLoader from 'Components/Loader/HOCLoader';
import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY_COLOR } from 'Config';
import usePosition from 'Components/Posistion';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
const CustomContainer = HOCLoader(Container);

const useStyles = makeStyles((theme) => ({
    paper: {
        padding: theme.spacing(3),
        textAlign: 'center',
        backgroundColor: '#f8f8f8',
        borderRadius: '10px',
        border: '1px solid #ccc',
        width: '50%',
        justifyContent: 'center'
    },
    header: {
        color: 'red',
        fontWeight: 'bold'
    },
    content: {
        marginTop: theme.spacing(2),
        marginBottom: theme.spacing(2),
        textAlign: 'left'
    },
    button: {
        backgroundColor: '#4CAF50',
        width: '70%',
        color: 'white',
        marginTop: theme.spacing(2),
        '&:hover': {
            backgroundColor: PRIMARY_COLOR
        }
    }
}));

export const GenerateSenderOTP = () => {
    const classes1 = useStyles();
    const formRef = useRef();
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const Mobile = location?.state?.Mobile;
    const ActiveDMTName = location?.state?.DMTName;
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');

    const { latitude, longitude } = usePosition();

    const [formObject, setFormObject] = useState({
        SenderMobile: Mobile,
        DMTName: ActiveDMTName,
        Agent_Latitude: latitude,
        Agent_Longitude: longitude,
        OTPType: 0,
        PublicIP: ' '
    });
    const submitHandle = async (values, setFieldValue) => {
        setResponseMessage('');

        const inputObj = {
            MobileNo: values.SenderMobile,
            DMTName: values.DMTName,
            PublicIP: values.PublicIP
        };

        var reqObj = JSON.stringify(inputObj);
        setLoading(true);
        var response = await GenerateOTPForSender(reqObj);
        setLoading(false);
        if (!response.isAuthorized) LOGOUT();

        if (!response.status) {
            setSeverity('error');
            setResponseMessage(response.data);
            setIsError(true);
            return;
        }

        var result = JSON.parse(response.data);

        let params = {
            SenderMobile: values.SenderMobile,
            OTPToken: result.Identifier
        };
        history.push('/EZPV1_VerifySenderOTP', params);
    };

    const FormValidationSchema = Yup.object({
        SenderMobile: Yup.string()
            .required(PLEASE_PROVIDE_VALID + 'mobile')
            .length(10, PLEASE_PROVIDE_VALID + 'mobile')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                innerRef={formRef}
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submitHandle}
                resetForm={formObject}
            >
                {({ values, setFieldValue }) => {
                    return (
                        <Form>
                            <Grid
                                item
                                container
                                margin="normal"
                                xs={12}
                                md={12}
                                sm={12}
                                lg={12}
                                spacing={2}
                            >
                                <Grid
                                    container
                                    spacing={1}
                                    style={{ textAlign: '-webkit-center' }}
                                >
                                    <Grid item xs={12} sm={12} md={12} lg={12}>
                                        <Paper className={classes1.paper}>
                                            <Typography
                                                variant="h5"
                                                className={classes1.header}
                                            >
                                                Sender KYC is pending !!!
                                            </Typography>
                                            <Box className={classes1.content}>
                                                <Typography variant="body1">
                                                    As per RBI Guidelines w.e.f.
                                                    November 1, 2024 Sender KYC
                                                    is mandatory for money
                                                    transfer transactions.
                                                </Typography>
                                                <Typography
                                                    variant="body1"
                                                    component="div"
                                                    style={{
                                                        marginTop: '10px'
                                                    }}
                                                >
                                                    Complete KYC following
                                                    simple steps
                                                    <ol
                                                        style={{
                                                            marginTop: '10px'
                                                        }}
                                                    >
                                                        <li>
                                                            Validate Sender
                                                            Mobile Number with
                                                            OTP; and
                                                        </li>
                                                        <li>
                                                            Authenticate
                                                            customer by scanning
                                                            his/her finger using
                                                            biometric device
                                                        </li>
                                                    </ol>
                                                </Typography>
                                            </Box>
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                className={classes1.button}
                                                disabled={loading}
                                            >
                                                Continue with Verification
                                            </Button>

                                            {loading && (
                                                <CircularProgress
                                                    size={24}
                                                    className={
                                                        classes.buttonProgress
                                                    }
                                                />
                                            )}
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Form>
                    );
                }}
            </Formik>
        </CustomContainer>
    );
};
//export GenerateSenderOTP;
